import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Checkbox,
  Flex,
  Heading,
  Icon,
  Image,
  Text,
} from '@chakra-ui/react'
import React, { useCallback, useState } from 'react'
import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { GetStartedContext } from '../../Context/GetStartedContext'

const AccordionCheckListData = ({ step, moveToNextStep, openAskArrowhead, setCurrentStep }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const user = useSelector((state) => state?.user.data)
  const { setTagPopup } = useContext(GetStartedContext)
  let imageSrc = ''

  // Set the image source based on the status
  switch (step.status) {
  case 'ACTIVE':
    imageSrc = '/assets/icons/active.svg'
    break
  case 'COMPLETE':
    imageSrc = '/assets/icons/complete.svg'
    break
  default:
    imageSrc = '/assets/icons/default.svg'
    break
  }

  const handleClick = useCallback(() => {
    if (step.title === 'View a meeting' && step.status === 'ACTIVE') {
      navigate(
        `/transcripts-summaries/summary?eventId=${
          user.id
        }_google_first_meeting&tab=HIGH&eventName=${'Start with Arrowhead! 🏹🚀'}`
      )
      moveToNextStep(1)
    }
    // if (step.title === 'Ask Arrowhead' && step.status === 'ACTIVE') {
    //   openAskArrowhead()
    // }
    if (step.title === 'Tag a meeting' && step.status === 'ACTIVE') {
      // if (
      //   `${location.pathname}${location.search}` ===
      //   `/transcripts-summaries/summary?eventId=${user.id}_google_first_meeting&tab=HIGH`
      // ) {
      //   setTagPopup(true)
      //   moveToNextStep(step.id)
      // } else {
      //   navigate(
      //     `/transcripts-summaries/summary?eventId=${user.id}_google_first_meeting&tab=HIGH`
      //   )
      //   setTagPopup(true)
      //   moveToNextStep(step.id)
      // }
      navigate(
        `/transcripts-summaries/summary?eventId=${user.id}_google_first_meeting&tab=HIGH&eventName=${'Start with Arrowhead! 🏹🚀'}`
      )
      setTagPopup(true)
      setCurrentStep(2.5)
      // moveToNextStep(step.id)
    }
    // if (step.title === 'Summon Arrowhead' && step.status === 'ACTIVE') {
    //   // if (
    //   //   `${location.pathname}${location.search}` ===
    //   //   `/transcripts-summaries/summary?eventId=${user.id}_google_first_meeting&tab=HIGH`
    //   // ) {
    //   //   console.log('Press the button as said')
    //   //   openAskArrowhead()
    //   // } else {
    //   //   navigate(
    //   //     `/transcripts-summaries/summary?eventId=${user.id}_google_first_meeting&tab=HIGH`
    //   //   )
    //   // }
    //   navigate(
    //     `/transcripts-summaries/summary?eventId=${
    //       user.id
    //     }_google_first_meeting&tab=HIGH&eventName=${'Start with Arrowhead! 🏹🚀'}`
    //   )
    //   openAskArrowhead()
    // }
  }, [location, step, user])
  return (
    <Box mb='4'>
      <Flex align='center' justify='space-between'>
        {imageSrc && <Image src={imageSrc} mr='1' />}

        <AccordionButton>
          <Box display='flex' w='100%' justifyContent='space-between'>
            <Text
              size='sm'
              fontWeight={step.status === 'ACTIVE' ? 800 : 500}
              color={step.status === 'ACTIVE' ? 'black' : '#222'}
              mr={0.7}
            >
              {step.title}
            </Text>
          </Box>
        </AccordionButton>
        <Box>{step?.description && <AccordionIcon color='black' />}</Box>
      </Flex>
      {step?.description && (
        <AccordionPanel px='20px' ml='5' w='250px'>
          <Text color='#222' mb='2'>
            {step.description}
          </Text>
          <Flex align='center'>
            {step?.buttonPreText && (
              <Text color='black' mr='2'>
                {step?.buttonPreText}
              </Text>
            )}
            <Button bgColor='black' onClick={handleClick}>
              {step.buttonText}
              {step.buttonShortcut ? (
                <Flex
                  bg='#F7FAFC'
                  h='24px'
                  ml={2}
                  px={2}
                  alignItems='center'
                  justifyContent='center'
                  borderRadius='6px'
                  border='1px solid #E2E8F0'
                >
                  <Text
                    color='#222222'
                    fontWeight='700'
                    fontSize='12px'
                    lineHeight='16px'
                    textTransform='uppercase'
                  >
                    {step?.buttonShortcut}
                  </Text>
                </Flex>
              ): <></>}
            </Button>
            {step?.buttonPostText && (
              <Text color='black' ml='2'>
                {step?.buttonPostText}
              </Text>
            )}
          </Flex>
        </AccordionPanel>
      )}
    </Box>
  )
}

const AccordionCheckList = ({ steps, moveToNextStep, openAskArrowhead, setCurrentStep }) => {
  return (
    <Box>
      {steps?.map((step) => (
        <AccordionItem key={step.id}>
          <AccordionCheckListData step={step} moveToNextStep={moveToNextStep} openAskArrowhead={openAskArrowhead} setCurrentStep={setCurrentStep} />
        </AccordionItem>
      ))}
    </Box>
  )
}

export default AccordionCheckList
